export default __webpack_public_path__ + "static/media/electrice.5b4a2e06.png";